import React, { useState, useRef } from "react";
import "./Contact.css";
import useClickOutside from "../../hooks/useClickOutside";

const whatsappNumbers = [
  { label: "UAE 1", number: "+971524230667" },
  { label: "UAE 2", number: "+971586567055" },
  { label: "Pakistan", number: "+923320440040" },
];

const callNumbers = [
  { label: "UAE 1", number: "+971524230667" },
  { label: "UAE 2", number: "+971586567055" },
  { label: "Pakistan", number: "+923320440040" },
];

export default function Contact() {
  const [showWhatsApp, setShowWhatsApp] = useState(false);
  const [showCall, setShowCall] = useState(false);

  const waRef = useRef(null);
  const callRef = useRef(null);

  useClickOutside(waRef, () => setShowWhatsApp(false));
  useClickOutside(callRef, () => setShowCall(false));

  return (
    <section className="contact" id="contact">
      <div className="contact__inner">
        {/* Info */}
        <div className="contact__info">
          <h2 className="contact__title">
            Get in <span>Touch</span>
          </h2>
          <p className="contact__subtitle">
            Let’s discuss your advertising needs. We’ll help you boost your brand visibility
            across TikTok, Google, YouTube, Facebook, and more.
          </p>

          <div className="contact__buttons">
            {/* WhatsApp */}
            <div className="popup-wrapper" ref={waRef}>
              <button
                onClick={() => {
                  setShowWhatsApp((v) => !v);
                  setShowCall(false);
                }}
                className="btn btn-whatsapp"
              >
                💬 Chat on WhatsApp
              </button>

              {showWhatsApp && (
                <div className="popup-options">
                  {whatsappNumbers.map((w, i) => (
                    <a
                      key={i}
                      href={`https://wa.me/${w.number.replace(/\+/g, "")}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {w.label} ({w.number})
                    </a>
                  ))}
                </div>
              )}
            </div>

            {/* Call */}
            <div className="popup-wrapper" ref={callRef}>
              <button
                onClick={() => {
                  setShowCall((v) => !v);
                  setShowWhatsApp(false);
                }}
                className="btn btn-call"
              >
                📞 Call Us
              </button>

              {showCall && (
                <div className="popup-options">
                  {callNumbers.map((c, i) => (
                    <a key={i} href={`tel:${c.number}`}>
                      {c.label} ({c.number})
                    </a>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Form */}
        <form className="contact__form">
          <input type="text" placeholder="Your Name" required />
          <input type="email" placeholder="Your Email" required />
          <textarea placeholder="Your Message" rows="5" required></textarea>
          <button type="submit" className="btn btn-primary">
            🚀 Send Message
          </button>
        </form>
      </div>
    </section>
  );
}
